import {
  getAPIHandler,
  postAPIHandler,
  rawAPICall,
} from "src/Apiconfig/service";
import { useState, useEffect, useContext } from "react";
import { api_base_url } from "src/Apiconfig/config";
import { AuthContext } from "src/context/Auth";
import moment from "moment";
import ApiConfig from '../Apiconfig/config'
export const useWalletUpdate = (userId, isRefreshed) => {
  const auth = useContext(AuthContext);
  const { userAddedWallets } = auth;
  const [locationUrl, setLocationUrl] = useState("");
  const [isResponded, setIsResponded] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [spotAccount, setSpotAccount] = useState([]);
  const [status, setStatus] = useState([]);

  //first call to load the user's wallet
  const loadUserWalletDetails = async () => {
    console.log("This is the API call from Parent")
    try {
      window.sessionStorage.setItem("lastUpdated", moment().format());
      setIsResponded(false);
      setIsRequesting(true);
      const response = await postAPIHandler({
        endPoint: "load",
       // id: userId,
      });
      // console.log("response--1", response);
      if (response.status === 202) {
        setLocationUrl(response.headers.location);
      } else {
        setIsRequesting(false);
        callFinalUpdate();
      }
    } catch (error) {
      console.log(error);
      setIsRequesting(false);
    }
  };

  const loadIndivitualWalletDetails = async (walletId) => {
    console.log("This is the API call for Manually Sync the Wallet !...")
    try {
      setIsResponded(false);
      setIsRequesting(true);
      const response = await rawAPICall({
        method: "POST",
        url: `${ApiConfig["load"]}` + "/" + walletId + "?fullResync=true",
      });

      // console.log("response--1", response);
      if (response.status === 202) {
        setLocationUrl(response.headers.location);
        getLocationData();
      } else {
        setIsRequesting(false);
        callFinalUpdate();
      }
    } catch (error) {
      console.log(error);
      setIsRequesting(false);
    }
  };

  //second call to hit api on 30 sec interval to get the new response location headers
  const getLocationData = async () => {
    try {
      setIsRequesting(true);
      const response = await rawAPICall({
        method: "GET",
        url: `${api_base_url}${locationUrl}`,
      });
      // console.log("response---2", response);
      // console.log("response-headers", response.headers);
      if (response.data.accounts) {
        setIsResponded(true);
        setSpotAccount(response.data.accounts);
        setStatus(response.data.status)
        // callFinalUpdate(response.headers.location);
        setIsRequesting(false);
      }
    } catch (error) {
      console.log(error);
      setIsRequesting(false);
    }
  };

  //final api call with the response headers and to terminate the second interval call
  const callFinalUpdate = async (newUrl) => {
    try {
      setIsRequesting(true);
      const response = await getAPIHandler({
        endPoint: "spotHoldings",
       // id: userId,
        paramsData: {
          pageNumber: 1,
          pageSize: 10,
        },
      });
      if (response.status === 200) {
        setIsResponded(true);
        setSpotAccount(response.data.accounts);
      }
      setIsRequesting(false);
      // console.log("response--final", response);
    } catch (error) {
      console.log("error---fianl", error);
      setIsRequesting(false);
    }
  };
  //function to call the second api when the response headers contains the location url for every 30 sec
  // useEffect(() => {
  //   let interval;
  //   if (locationUrl !== "" && !isResponded) {
  //     getLocationData();
  //     interval = setInterval(() => {
  //       getLocationData();
  //     }, 60000);
  //   }
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [locationUrl, isResponded]);

  // //function to call the load api when the user id is available
  // useEffect(() => {
  //   if (userId && userAddedWallets?.length > 0) {
  //     loadUserWalletDetails();
  //   }
  // }, [userId, userAddedWallets, isRefreshed]);

  return {
    isRequesting,
    spotAccount,
    isResponded,
    loadUserWalletDetails,loadIndivitualWalletDetails,
  };
};
